import React from 'react';
import { useTranslation } from "react-i18next";
import Message from '../../jo-components/misc/message/message';
import { Button } from '../../ui';
import ResaleBreakdown from './components/resaleBreakdown';
import './resale.css';


export default function DeleteResale({ onSubmit = () => {}, config }) {
    const { t } = useTranslation();
    const formConfig = config['resale-ticket-delete-form'];
    const initialPrice = formConfig?.resale_breakdown?.price?.value ?? null;
    const initialPrivate = formConfig?.resale_option?.value ?? false;
    const [state, setState] = React.useState({
        price: initialPrice,
        is_private_resale: initialPrivate,
    });
    const {title, message} = formConfig;

    return (
        <div className='resale-container'>
            <div className='wz-breakdown-container'>
                <div className='wz-breakdown-title'>{title}</div>
                {
                    message && <Message title={message.title} description={message.body} type={message.type}/>
                }
                <ResaleBreakdown 
                    data={formConfig} state={state} setState={setState} mode='resale-menu' onSubmit={onSubmit} />

                <div className='wz-breakdown-cta'>
                    <Button
                        className='wz-button wz-cancel-cta'
                        label={t('widget.resale.breakdown.cta-confirm')}
                        onClick={onSubmit}
                    />
                </div>
            </div>
        </div>
    )
}